var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('head-el'),_c('router-view'),_c('foot-el')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }